import React, { Component } from 'react';
import SVG from 'react-inlinesvg';

import './_section-container.scss';
import LOGO from "../../static/logo.svg";

const FeatItem = (props) => (
	<div className="col-lg-4">
		<div className="featurettes-img"><img src={props.image} width="347" height="195" /></div>
		<h4>{props.title}</h4>
		<p>{props.content}</p>
	</div>
)

const TeamMember = (props) => (
	<div className="col-lg-4">
	  <div className="flipper">
	  		<div className="front">
	  			<img src={props.image} />
	  		</div>
	  		<div className="back">
	  			<strong>{props.title}</strong>
	  			<a href={props.link}>{props.social}</a>
	  			<p>{props.content}</p>
	  		</div>
	  	</div>
	</div>
)

class NewsListing extends Component {
  constructor(props) {
	  		//console.log(props);
	        super(props);
	        
	        this.toggleClass = this.toggleClass.bind(this);
	        
	        this.state = {
	            cubeActive: false,
	            
	          }	        
	        };
	        
	        toggleClass() {
		        const currentState = this.state.cubeActive;
		        this.setState({ cubeActive: !currentState });
		    };
	
  render() {
	  const feats = [this.props.data.parts[0], this.props.data.parts[1], this.props.data.parts[2]]
	  const team = [this.props.data.parts[5], this.props.data.parts[6], this.props.data.parts[7]]
	 return (<section className={"section-container angled" + (this.state.cubeActive ? ' cube-active' : '')} id="about" name="about">
	  <div className="cube">
		    <div className="container front-face">
			      <div className="row">
			        <div className="col-12">
			          <img src={LOGO} className="loguito" />
			          <p className="lead text-center" dangerouslySetInnerHTML={{ __html: this.props.data.title }}>
			          		
			          </p>
			          
			        </div>
			      </div>
			      
			      <div className="row text-center featurettes">
			      
			      	{feats.map((feat, index) => {
					   return <FeatItem 
			          	title={feat.title} 
			          	image={feat.image}
			          	content={feat.content}
				        key={'key-'+feat.title}
			          	/>  
				    })}
					
						</div>
				
				
		    </div>
		    <div className="container down-face">
			      <div className="row">
			        <div className="col-12 text-center">
			        	<h2>{this.props.data.parts[4].title}</h2> 
			        	<p className="lead">{this.props.data.parts[4].content}</p>
			        </div>
			      </div>
			      <div className="row">
			      {team.map((member, index) => {
					   return <TeamMember 
			          	title={member.title} 
			          	image={member.image}
			          	content={member.content}
			          	link={member.link}
			          	social={member.social}
				        key={'key-'+member.title}
			          	/>  
				    })}
			      	
			      </div>
			      <div className="row">
					<div className="col-12 text-center">
						<button className="btn" onClick={this.toggleClass}>About Us</button>
					</div>
				</div>
				</div>
			</div>
		  </section>)
	 }
  };
  
export default NewsListing;



// WEBPACK FOOTER //
// ./src/components/section-container/index.js